import React from 'react';

import TimelineContextMenu from './TimelineContextMenu';
import { TimelineTrack } from './TimelineTrack';

import type { ElementState } from '@src/renderer/ElementState';
import type { Story } from '@src/types.ts/story';

interface TimelineTracksProps {
  tracks: [number, ElementState[]][];
  activeTracks: number[];
  scale: number;
  trackWidth?: number;
  onContextMenu: (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    element: ElementState,
  ) => void;
  onPasteContextMenu: (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    track: number,
    elements: ElementState[],
  ) => void;
  onElementClick: (element: ElementState) => void;
  contextMenuState: any;
  story?: Story;
  getTrackInfo: (
    track: number,
    elements: ElementState[],
  ) => {
    isOriginalVideo: boolean;
    isText: boolean;
    isShape: boolean;
    isLogo: boolean;
    isComposition: boolean;
    isActive: boolean;
    height: number;
  };
}

export const TimelineTracks: React.FC<TimelineTracksProps> = ({
  tracks,
  trackWidth,
  onContextMenu,
  onPasteContextMenu,
  onElementClick,
  story,
  getTrackInfo,
}) => {
  return (
    <>
      {tracks.map(([track, elements]) => {
        const trackInfo = getTrackInfo(track, elements);
        const { isActive, isOriginalVideo, isLogo, isComposition } = trackInfo;

        if (isOriginalVideo) {
          return (
            <React.Fragment key={track}>
              <TimelineTrack
                key={`${track}-video`}
                elements={elements}
                story={story}
                isActive={isActive}
                isOriginalVideo={true}
                width={trackWidth}
                onElementCrtlClick={onElementClick}
              />
              <TimelineTrack
                key={`${track}-audio`}
                type="linked-audio"
                elements={elements}
                story={story}
                isActive={isActive}
                width={trackWidth}
                onElementCrtlClick={onElementClick}
              />
            </React.Fragment>
          );
        } else {
          return (
            <React.Fragment key={track}>
              <TimelineContextMenu
                action="copy"
                secondaryActions={['clearVolumeKeyPoints']}
              />
              <TimelineTrack
                key={track}
                track={track}
                elements={elements}
                story={story}
                isActive={isActive}
                onContextMenu={onContextMenu}
                handlePasteContextMenu={onPasteContextMenu}
                isLogo={isLogo}
                isComposition={isComposition}
                width={trackWidth}
                onElementCrtlClick={onElementClick}
              />
            </React.Fragment>
          );
        }
      })}
    </>
  );
};
